<template>
  <div class="scrollTop-container">
    <div :class="['scrollItems',scrollTop>300?'scrollItems-down':'']" v-if="isShowScrollItems($route.name)">
      <div :class="['scrollTop-item',item.isActive?'scrollTop-item-active':'']" v-for="(item,index) in currentItems" :key="index" @click="scrollTo(item.top,item.el,item)" @mouseenter="item.isHover=true" @mouseleave="item.isHover=false">
        <i :class="['fa',iconMatcher(item.name),'scrollTop-item-icon']"></i>
        <transition name="fade">
        	<span class="scrollTop-item-name" v-if="item.isHover">{{$t(item.name)}}</span>
        </transition>
      </div>
    </div>
    <transition name="fade">
      <div class="scrollTop-top" @click="scrollTo(0)" v-if="scrollTop>300">
        <div class="scrollTop-top-name">
          UP
        </div>
        <div class="scrollTop-top-icon">
          <el-icon class="el-icon-caret-top">
          </el-icon>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

import iconTranslator from './../filters/icon-translate.js'

export default {
  props: {
    scrollItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentItems: [],
      scrollTop: 0
    }
  },
  created() {
    this.currentItems = this.scrollItems ? this.scrollItems : [];
  },
  watch: {
    scrollItems(n) {
      this.currentItems = n;
    }
  },
  methods: {
    scrollTo(target, el) {
      const currentTop = el ? (el.getBoundingClientRect().top + window.pageYOffset) : target;
      if (el && Math.abs(currentTop - target) > 20) {
        target = currentTop;
        this.$store.commit('so/setScrollItems', [...document.querySelectorAll('.scroll-item-name')].map(item => {
          if (item.hasAttribute('scrollitem')) {
            return { name: item.getAttribute('scrollitem'), el: item, top: item.getBoundingClientRect().top + window.pageYOffset, isActive: false ,isHover:false};
          }
        }).sort((a,b)=>a.top-b.top>=0));
      }
      window.scrollTo(0, target < 21 ? target : target - 20);
    },
    scrollHandler(e) {
      const top = e.target.scrollingElement.scrollTop;
      this.scrollTop = top;
      const current = this.currentItems.findIndex((item, index) => {
        return !(top < item.top - 50) && (index > -1 && index < this.currentItems.length - 1 ? !(top > this.currentItems[index + 1].top - 50) : true);
      });
      current > -1 ? this.currentItems = this.currentItems.map((item, index) => {
        item.isActive = current !== index ? false : true;
        return item;
      }) : this.currentItems = this.currentItems.map(item => {
        item.isActive = false;
        return item;
      });
    },
    iconMatcher(prop){
    	return iconTranslator.matcher(prop);
    },
    isShowScrollItems(route){
      const matchedRoutes=['soCompany','soEmail','soSingle'];
      return matchedRoutes.includes(route);
    }
  },
  mounted() {
    if (window) {
      window.addEventListener('scroll', this.scrollHandler);
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

</script>
<style scoped>

.scrollItems {
  right: calc(6% - 1px);
  bottom: calc(50% - 175px);
  position: fixed;
  transition: all 0.3s;
  z-index: 5;
}

.scrollItems-down {
  bottom: 178px;
}

.scrollTop-item-icon{
	font-size: 19px;
}

.scrollTop-item-name{
	position: absolute;
    right: 100%;
    display: inline-block;
    padding: 0px 12px;
    background: #409EFF;
    width: max-content;
    border-radius: 4px;
    margin-right: 12px;
    color: #fff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.scrollTop-item {
  background: #409EFF;
  border-radius: 4px;
  margin-bottom: 5px;
  width: 40px;
  height: 40px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.scrollTop-item-active {
  background: #fff;
  color: #409EFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.scrollTop-top {
  cursor: pointer;
  position: fixed;
  bottom: 140px;
  right: 6%;
  z-index: 5;
}

.scrollTop-top-name {
  width: 38px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  letter-spacing: 2px;
  font-size: 14px;
  background: #409EFF;
  color: #fff;
  font-weight: 600;
  border-radius: 4px;
}

.scrollTop-top-icon {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 6px);
}

.el-icon-caret-top {
  font-size: 22px;
  color: #409EFF;
  padding: 6px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-icon-caret-top:hover {
  background: rgb(240, 240, 240);
}

</style>



// WEBPACK FOOTER //
// src/common/components/scrollTop.vue